import get from 'lodash.get'
import throttle from 'lodash.throttle'
import { Toast } from 'vant'
import { MESSAGE_NAME } from '@/constants/message'
import { BLUR_TYPING_INPUT } from '@/constants/pub_sub'
import { trimHTML, filterBrAndEmoji, setEndOfContenteditable } from '@/utils/editor'
import { getSelectionTextInfo, scrollTo } from '@/utils/dom'
// import { getClipboardText, getClipBoardTypes } from '@/utils/clipboard'
import { sendMessage } from '@/utils/message_send'
import { getRelatedQuestion, istheinput} from '@/api/chat'
import { getRequest, ismobile } from '@/utils'
import { uploadImgBusiness, uploadFileBusiness } from '../utils/upload_business'

const ENTER_KEYCODE = 13
const THROTTLE_TIME = 500 // input 触发查询相关问题的频率
const RELATED_QUESTION_NUMBER_FOR_MOBILE = 3 // 相关问题的显示数量限制（移动端）
// const LIMIT_WORD = 220
let typingTimer = null

export default {
    data () {
        return {
            isCompositing: false,
            isTypingFocus: false,
            typingContent: '',
            relatedQuestionKeyword: '',
            curValueForIE: '',
            setRelatedQuestionThrottled: throttle(this.setRelatedQuestion, THROTTLE_TIME),
            globalMousedownForDesktopSelf: this.globalMousedownForDesktop.bind(this)
        }
    },
    computed: {
        hasTypingContent () {
            return trimHTML(this.typingContent) !== ''
        },
        isShowTypingPlaceholder () {
            if (this.isTypingFocus) {
                return false
            }
            return this.typingContent === ''
        },
        robotName () {
            return get(this.$eventBus.robot, 'name', '')
        },
        typingPlaceholder () {
            // if (this.$eventBus.isDesktop) {
            //     return '按Enter键发送，按Ctrl+Enter键换行'
            // }
            return '请输入您要咨询的问题'
        },
        isIos () {
            return this.$eventBus.isIos
        }
    },
    watch: {
        hasTypingContent (value) {
            if (!value) {
                this.clearRelatedQuestion()
            }
        }
    },
    methods: {
        focusIfBlur () {
            const chatInputTyping = this.$refs.chatInputTyping
            if (document.activeElement !== chatInputTyping) {
                chatInputTyping.focus()
                setEndOfContenteditable(chatInputTyping)
            }
        },
        clickChatInput () {
            this.focusChatInput()
        },
        focusChatInput () {
            this.isTypingFocus = true
            this.closeAllPanel()
            /**
             * 在 ios 中，弹出键盘时页面大小仍然保持视口大小
             * 可能导致处于底部的输入框不可见
             */
            if(ismobile()) {
                setTimeout(() => {
                    document.querySelector('.footer').scrollIntoView()
                }, 300)
            }
        },
        blurChatInput () {
            this.isTypingFocus = false
            /**
             * 用于点击关联问题
             *
             * 对于智言测试机 iPhone 5，点击关联问题，键盘消失，但仍占位
             * 关联问题绑定 click事件，通过 setTimeout scrollIntoView 修复
             * 若关联问题绑定 mousedown（touchstart） 事件，直接通过 scrollIntoView 修复
             */
            setTimeout(() => {
                if(ismobile()) {
                    document.querySelector('.header').scrollIntoView()
                }
                /**
                 * 输入框的内容滚到最下面
                 * 放在 nextTick / setTimeout 才生效
                 */
                scrollTo(this.$refs.chatInputTyping, 0, 'scrollHeight')
            }, 0)
        },
        compositionstart () {
            this.isCompositing = true
        },
        compositionend () {
            this.isCompositing = false
            this.setRelatedQuestionThrottled()
        },
        async setRelatedQuestion () {
            if (!this.hasTypingContent) {
                return
            }
            this.relatedQuestionKeyword = filterBrAndEmoji(this.typingContent)
            this.relatedQuestionKeyword = trimHTML(this.relatedQuestionKeyword)
            if (this.relatedQuestionKeyword && this.relatedQuestionKeyword.length > 10) {
                return
            }
            const relatedQuestion = await getRelatedQuestion(
                this.$eventBus.uid,
                this.$eventBus.chatSource,
                this.$eventBus.entryKey,
                this.relatedQuestionKeyword
            )
            if (this.isTypingFocus
                && this.hasTypingContent
                && Array.isArray(relatedQuestion)
                && relatedQuestion.length > 0) {
                this.$emit(
                    'setRelatedQuestion',
                    relatedQuestion.slice(0, this.isDesktop
                        ? relatedQuestion.length
                        : RELATED_QUESTION_NUMBER_FOR_MOBILE
                    )
                )
            }
        },
        clearRelatedQuestion () {
            this.setRelatedQuestionThrottled.cancel()
            this.$emit('setRelatedQuestion', [])
        },
        inputByTyping () {
            /**
             * https://developer.mozilla.org/zh-CN/docs/Web/API/Element/innerHTML
             * Note: 如果一个 <div>, <span>, 或 <noembed> 节点有一个文本子节点，该节点
             * 包含字符 (&), (<),  或(>), innerHTML 将这些字符分别返回为&amp;, &lt; 和 &gt; 。
             * 使用Node.textContent  可获取一个这些文本节点内容的正确副本。
             */
            if(typingTimer) {
                clearTimeout(typingTimer)
            }
            this.typingContent = this.$refs.chatInputTyping.innerHTML
            // if (this.$refs.chatInputTyping.innerHTML.length > LIMIT_WORD) {
            //     this.$refs.chatInputTyping.innerHTML = this.$refs.chatInputTyping.innerHTML.substring(0, LIMIT_WORD)
            //     this.typingContent = this.$refs.chatInputTyping.innerHTML.substring(0, LIMIT_WORD)
            //     this.keyAction()
            // }
            if (this.isCompositing) {
                istheinput(this.$eventBus.uid, true, this.typingContent)
            }
            this.setRelatedQuestionThrottled()
            typingTimer = setTimeout(() => {
                const content = this.typingContent === '<br>' ? '' : this.typingContent
                istheinput(this.$eventBus.uid, false, content)
                typingTimer = null
            }, 2000)
        },
        keyAction () {
            let textbox = this.$refs.chatInputTyping
            let sel = window.getSelection()
            let range = document.createRange()
            range.selectNodeContents(textbox)
            range.collapse(false)
            sel.removeAllRanges()
            sel.addRange(range)
        },
        enterKey () {
            if (this.isDesktop) {
                if (this.$refs.theRelatedQuestion
                    && this.$refs.theRelatedQuestion.setTypingContentIfSelected()) {
                    this.clearRelatedQuestion()
                    setEndOfContenteditable(this.$refs.chatInputTyping)
                    return
                }
                this.sendTypingContent()
            } else {
                this.createNewLine()
            }
        },
        createNewLine () {
            /**
             * 对于 contentEditable，回车默认是通过 div 包装元素实现换行
             * 现在替换为 br
             * 对于光标在末尾，使用两个 br 是因为第二个 br 会在输入时替换为输入内容
             */
            const { atEnd } = getSelectionTextInfo(this.$refs.chatInputTyping)
            let newLine = atEnd ? '<br><br>' : '<br>'
            document.execCommand('insertHTML', false, newLine)
            if (atEnd) {
                scrollTo(this.$refs.chatInputTyping, 0, 'scrollHeight')
            }
        },
        clickSendBtnOfDesktop () {
            if (this.hasTypingContent) {
                this.sendTypingContent()
            } else {
                this.clickChatInput()
            }
        },
        sendTypingContent () {
            if (!this.hasTypingContent) {
                return
            }
            if (!this.$eventBus.isSocketConnected) {
                this.$toast.fail('已断开连接，请稍后再试')
                return
            }
            if(getRequest().robot_key) {
                if(this.typingContent==='转人工'||this.typingContent==='人工') {
                    Toast('当前对话测试不允许触发转人工指令或转人工的FAQ')
                    this.emptyTypingContent()
                    return
                }
            }

            // 判断是否为首次发送，调用着陆和首次聊天
            if (this.$store.state.is_current_service_none) {
                this.$store.commit('setCurrentService', false)
                this.$emit('sendFirstChat')
            }

            sendMessage({
                type: 'base',
                detailType: MESSAGE_NAME.TEXT,
                content: this.typingContent
            })
            if (this.chatTarget=='robot') {
                this.$eventBus.$emit('showinputstatus', {is_input:true})
            }
            istheinput(this.$eventBus.uid, false, '')
            this.emptyTypingContent()
            this.$parent.setMessageRead()
            this.closeAllPanel()
        },
        setTypingContent (content) {
            this.typingContent = content
            this.$refs.chatInputTyping.innerHTML = content
        },
        emptyTypingContent () {
            this.typingContent = ''
            this.$refs.chatInputTyping.innerHTML = this.typingContent
        },
        paste (event) {
            event.preventDefault()
            const { atEnd } = getSelectionTextInfo(this.$refs.chatInputTyping)

            //let text = getClipboardText(event)
            let clipboardData = window.clipboardData
            console.log(clipboardData)
            let text = null
            if (clipboardData && clipboardData.setData) {
                // IE
                text = clipboardData.getData('text')
            } else {
                clipboardData = ( event.originalEvent || event ).clipboardData
                text = clipboardData.getData('text/plain')
            }
            console.log(event.clipboardData)
            try {
                //剪切板第一个类型为文件
                if (clipboardData.types[0] === 'Files') {
                    let blob = event.clipboardData.files[0]
                    if (blob.type.match(/^image/)) {
                        uploadImgBusiness(blob)
                    } else {
                        uploadFileBusiness(blob)
                    }
                    return
                }
            } catch (e) {
                console.log(e)
            }

            // IE
            if (document.body.createTextRange) {
                let textRange
                if (document.selection) {
                    textRange = document.selection.createRange()
                } else if (window.getSelection) {
                    let range = window.getSelection().getRangeAt(0)
                    // 创建临时元素，使得TextRange可以移动到正确的位置
                    let tempEl = document.createElement('span')
                    tempEl.innerHTML = '&#FEFF;'
                    range.deleteContents()
                    range.insertNode(tempEl)
                    textRange = document.body.createTextRange()
                    textRange.moveToElementText(tempEl)
                    tempEl.parentNode.removeChild(tempEl)
                }
                textRange.text = text
                textRange.collapse(false)
                textRange.select()
            } else { // Chrome之类浏览器
                /**
                 * 由于 insertText 不能将 br、&nbsp; 作为标签，
                 * 这里简单处理：直接将它们替换为空格。
                 * 更改的做法应该是：
                 * 1. 记录当前光标的位置
                 * 2. 粘贴内容经过 onlyText 处理后，记录 br 和 &nbsp; 的位置
                 * 3. onlyText 后的内容再经过 replaceTag 方法将 br 和 &nbsp; 替换为空
                 * 4. 根据步骤 2 记录的位置，遍历这些位置，并结合步骤 1 和前一次执行该
                 *    步骤后光标的偏移量所在位置，插入 br 或 &nbsp;（或逆向记录光标的位置，
                 *    避免前面插入 br 或 &nbsp; 导致产生的光标偏移量。但未尝试。）
                 * 5. 将光标移至复制内容后面
                 */
                let result = onlyText(text)
                // if (result.length > LIMIT_WORD) {
                //     result = result.substring(0, LIMIT_WORD)
                // }
                //result = replaceTag(result, /<br>/g)
                result = replaceTag(result, /\n/g, '<br>')
                console.log(result)
                //result = replaceTag(result, /&nbsp;/g)
                document.execCommand('insertHTML', false, result)
            }

            // 若光标在最后
            if (atEnd) {
                scrollTo(this.$refs.chatInputTyping, 0, 'scrollHeight')
            }

            /**
             * 去掉标签等
             */
            function onlyText (text) {
                let result = ''
                let textarea = document.createElement('textarea')
                textarea.innerHTML = text
                result = textarea.value
                textarea = null
                return result
            }

            function replaceTag (text, searchValue, replaceValue = ' ') {
                return text.replace(searchValue, replaceValue)
            }
        },
        globalMousedownForDesktop (event) {
            const isCtrl = event.ctrlKey
            const keyCode = event.keyCode

            // enterKey
            if (!isCtrl && keyCode === ENTER_KEYCODE) {
                this.enterKey()
                return
            }

            // 以下所有代码均是涉及【theRelatedQuestion】
            if (!this.$refs.theRelatedQuestion) {
                return
            }

            // ↓
            if (keyCode === 40) {
                this.$refs.theRelatedQuestion.next()
                return
            }

            // ↑
            if (keyCode === 38) {
                this.$refs.theRelatedQuestion.prev()
                return
            }
        },
        bindGlobalMousedownForDesktop () {
            document.addEventListener('keydown', this.globalMousedownForDesktopSelf, false)
        },
        unbindGlobalMousedownForDesktop () {
            document.removeEventListener('keydown', this.globalMousedownForDesktopSelf, false)
        },
        /**
         * ie：文本输入框内的 emoji 图片可以调整大小
         * from: https://stackoverflow.com/a/21875990
         */
        // S fix ie emoji resize
        controlselectHandler (event) {
            event.preventDefault()
        },
        disableImgResizingForIE () {
            document.body.addEventListener('mscontrolselect', this.controlselectHandler, false)
        },
        unbindDisableImgResizingForIE () {
            document.body.removeEventListener('mscontrolselect', this.controlselectHandler, false)
        },
        // E fix ie emoji resize
        /**
         * ie 不支持在 contenteditable 上触发 input 事件，现改为模拟 change
         */
        // S fix ie contenteditable input event
        setCurValueForIE () {
            /**
             * 因为 IE 的 chatInputTyping.innerHTML 初始值有可能是 <br>
             * 所以这里没用 this.typingContent（初始值为 ''）
             */
            this.curValueForIE = this.$refs.chatInputTyping.innerHTML
        },
        inputByTypingForIE (event) {
            // enter
            if (event.keyCode === ENTER_KEYCODE) {
                return
            }
            if (this.curValueForIE !== this.$refs.chatInputTyping.innerHTML) {
                this.setCurValueForIE()
                this.inputByTyping()
            }
        },
        fixInputEventForIE () {
            this.$refs.chatInputTyping.addEventListener('focus', this.setCurValueForIE, false)
            this.$refs.chatInputTyping.addEventListener('keyup', this.inputByTypingForIE, false)
        },
        unbindFixInputEventForIE () {
            this.$refs.chatInputTyping.removeEventListener('focus', this.setCurValueForIE, false)
            this.$refs.chatInputTyping.removeEventListener('keyup', this.inputByTypingForIE, false)
        }
        // E fix ie contenteditable input event
    },
    mounted () {
        this.$eventBus.$on(BLUR_TYPING_INPUT, () => {
            if (this.isTypingFocus) {
                this.$refs.chatInputTyping.blur()
            }
        })
        if (this.$eventBus.isIENotIncludeEdge) {
            this.fixInputEventForIE()
            this.disableImgResizingForIE()
        }
        if (this.isDesktop) {
            this.bindGlobalMousedownForDesktop()
        }
    },
    beforeDestroy () {
        this.$eventBus.$off(BLUR_TYPING_INPUT)
        if (this.$eventBus.isIENotIncludeEdge) {
            this.unbindFixInputEventForIE()
            this.unbindDisableImgResizingForIE()
        }
        if (this.isDesktop) {
            this.unbindGlobalMousedownForDesktop()
        }
    }
}
